import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import React from 'react';
import styles from './index.module.scss';

const images = {
    eu: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745836340479/pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745836340301/h5.jpg',
    },
    uk: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745836340479/pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745836340301/h5.jpg',
    },
    de: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745745611462/800W%E9%99%90%E5%88%B6_DE%20.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745745611955/M_800W%E9%99%90%E5%88%B6_DE%20.jpg',
    },
    fr: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745745612810/800W%E9%99%90%E5%88%B6_FR%20.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745745611789/M_800W%E9%99%90%E5%88%B6_FR%20.jpg',
    },
    it: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745745612618/800W%E9%99%90%E5%88%B6_IT%20.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745745611578/M_800W%E9%99%90%E5%88%B6_it%20.jpg',
    },
    es: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745745612412/800W%E9%99%90%E5%88%B6_es%20.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745745612192/M_800W%E9%99%90%E5%88%B6_es%20.jpg',
    },
};

const SectionA2: React.FC = () => {
    const { t: t1 } = useLang('theProduct.SectionA1');
    const { t } = useLang('theProduct.SectionA2');
    const { locale } = getLocal() as { locale: 'eu' | 'uk' | 'de' | 'fr' | 'it' | 'es' };

    return (
        <div className={`eco-content GtmModuleData-section`} data-section-id="SectionA2" data-section-title={t('item0_title')}>
            <EcoSpace hPad="100px" />
            <section className={styles.SectionA2}>
                <EcoSectionCommon title={t1('item0_title')} />
                <div className="SectionA2-desc SectionA2-desc1">
                    {t.rich('title', {
                        text1: (text: string) => <span className="SectionA2-color2">{text}</span>,
                    })}
                    {t('desc')}
                </div>
                <EcoSpaceSmall />
                <EcoImg pc={images[locale]?.pc} h5={images[locale]?.h5} className="SectionA2-img" isOpenLazy />
            </section>
        </div>
    );
};

export default SectionA2;
